<div class="row ss-top-menu">
  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-5">
    <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">Dashboard <i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Vendors</span>
  </div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
	<span id="notificationMessageText">{{errorMessage}}</span>
	<a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>

<div class="container-set container-set-change mt-4">
  <div class="row">
  	<div class="col-6">
  		<div class="ss-searchbox">
	      <i class="fa fa-search"></i>
	      <input class="form-control" type="text" placeholder="Type in name, contact person,contact number, pan no.,email to search..." #search (keyup.enter)="onKey($event)">
	    </div>
  		
  	</div>
  	<div class="col-md-6 pull-right">
  		<div class="row mt-3">
  
  			<div class="col-md-12">
  				<div class="filterdiv">
  					<!-- <p class="d-inline-block m-0">Show By - </p>
		  	        <select class="filterSelect col-sm-2" (change)="filterPage($event)">

					  	<option value='1'>1</option>
					  	<option value="2">2</option>
					  	<option value="3">3</option>
					  	
				    </select>  -->
  					<p class="d-inline-block m-0">Filter By - </p>
		  	        <select class="filterSelect col-sm-2" (change)="filterEvents($event)">

					  	<option value='all'>All</option>
					  	<option value="city">Servicable City</option>
					  	<option value="category">Category</option>
					  	
				    </select> 
				    <select class="filterSelect" style="display: none" id="cityId" (change)="filterCities($event)">
				    	<option value='all'>All</option>
				    	<option *ngFor="let obj of city_list" value="{{ obj.id }}">{{ obj.name | replaceChar }}</option>
				    </select> 
				    <select class="filterSelect " style="display: none" id="categoryId" (change)="filterCategories($event)">
				    	<option value='all'>All</option>
				    	<option *ngFor="let cb of categories" value="{{ cb.id }}">{{ cb.category_name }}</option>
				    </select> 
				    <select class="filterSelect" style="display: none" id="SubcategoryId" (change)="filterSubCategories($event)">
				    	<option value='all'>All</option>
				    	<option *ngFor="let subC of subCategoryList" value="{{ subC.id }}">{{ subC.category_name }}</option>
				    </select> 	
  					
  				</div>
  					
  			</div>
  			
  		</div>
  	   
  	</div>
   	
  </div>
	
</div>
<div class="row mt-4"> 
  <div class="col-12">
	  <button class="btn  bt-boq pull-right" data-target="#addVendorModal" data-toggle="modal">Add vendor</button>
  </div>	
	
</div>
<div class="container-set">

	<div class="row" style="padding: 16px">
        <div class="col-md-12">
       

	        <collapsible-table [type]="'accordion'" bordered class="table">

	          <thead class="thead-dark">

	            <collapsible-table-row>
	              <th scope="col" class="firstTh">#</th>
	              <th scope="col">VENDOR NAME</th>
	              <th scope="col">ADDRESS</th>
	              <th scope="col">PERSON NAME</th>
	              <th scope="col">NUMBER</th>
	              <th scope="col">EMAIL</th>
	              <th scope="col"></th>
	              <th scope="lastTh" class="lastTh"></th>
	                
	            </collapsible-table-row>
	          </thead>
	         
	          <tbody style="background: white">
	            <ng-container *ngFor="let vendor of itemList | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  }  let i = index" [attr.data-index]="i" >
	              <collapsible-table-row [detail]="detail1"  (click)="getVendorDetails(vendor.id)">
	                <td style="min-width: 1rem;">{{((current_page-1) * per_page) + (i+1)}}</td>
	                <td class="capitalize">
	                  {{vendor.name}}
	                </td>
	               
	                <td>{{vendor.address}}</td>
	                <td class="capitalize">{{vendor.contact_person}}</td>
	                <td class="capitalize">{{vendor.contact_number}}</td>
	                <td class="capitalize">{{vendor.email}}</td>
	     	        <td>
	     	        	
	     	        </td>
	     	        <td>
	     	        	<i class="ion-android-more-vertical  ss-3-dot-drop" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
	     	        	<div class="dropdown-menu pt-2 pb-2" style="font-size: 14px;">
                            <a class="dropdown-item addCursor" (click)="confirmAndDelete(vendor.id)">Delete</a>
                            <a class="dropdown-item addCursor" data-toggle="modal" data-target="#vendorUpdateModal" (click)="getVendorForUpdate(vendor.id)">Edit</a>
                            
                        </div>
	     	        </td>
	              </collapsible-table-row>
	              <collapsible-table-row-detail style="box-shadow: none;" #detail1>
	              	<div *ngIf="vendor_det">
		                <div class="row" style="border-bottom: 1px solid #dcd7d7;" >
		               	  <div class="col-md-12">
		               		<h5 class="heading-change">Bank Details:</h5>
		               	  </div>
		                </div>
		                <div  class="row style-chng">
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Pan Card:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.pan_no }}" readonly >
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">GST Registration Number:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.gst_reg_no }}" readonly>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Account Holder Name:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.account_holder }}" readonly>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Account Number:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.account_number }}" readonly>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Bank Name:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.bank_name }}" readonly>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Branch Name:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.branch_name }}" readonly>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">IFSC Code:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.ifsc_code }}" readonly>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Uploaded Pan Copy:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.pan_copy }}" readonly>
		                			<a href="{{ vendor_det.pan_copy }}" class="download-change" target="_blank">View</a>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Uploaded GST Copy:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.gst_copy }}" readonly>
		                			<a href="{{ vendor_det.gst_copy }}" class="download-change" target="_blank" >View</a>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Uploaded Cancelled Cheque:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.cancelled_cheque }}" readonly>
		                			<a href="{{ vendor_det.cancelled_cheque }}" class="download-change" target="_blank">View</a>
		                		</div>
		                		
		                	</div>
		                	<!-- <div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Category:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor.vendor_categories }}" readonly>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">Sub Category:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor.contact_person }}" readonly>
		                		</div>
		                		
		                	</div> -->
		                	<div class="col-md-4">
		                		<div class="form-group">
		                			<label class="ss-form-label">City:</label>
		                			<input type="text" class="form-control ss-form-control" value="{{ vendor_det.city }}" readonly>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-4">
		                		<div class="form-group" >
		                			<label class="ss-form-label">Servicable Cities:</label>
		                			<ng-container *ngFor="let obj of city_name">
		                			  <input type="text" class="form-control ss-form-control" value="{{ obj.itemName | replaceChar  }}" readonly>
		                		  </ng-container>
		                		</div>
		                		
		                	</div>
		                	<div class="col-md-12">
		                		<div class="form-group" *ngIf="vendor_det">
		                			<label class="ss-form-label">Category:</label>
		                			<br>
		                			<span class="badge badge-primary mr-3" *ngFor="let item of vendor_det.vendor_sub_categories">{{item.parent_category_name}} - {{item.category_name}}</span>
		                		</div>
		                		
		                	</div>
		                </div>
			        </div>        
	              </collapsible-table-row-detail> 
	            </ng-container>
	          </tbody>     
	        </collapsible-table>
	        <div class="text-center" *ngIf="itemList && itemList.length >0">
		        <pagination-controls autoHide="true" (pageChange)="current_page = getVendorList($event)"></pagination-controls>
		    </div>
	        
       
        </div>
        <div class="col-md-12 not-found " *ngIf="itemList && itemList.length==0 ">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray;background: white;">Nothing to show...</p> 
          </div> 
	</div>
</div>



<!-- Modal create for Vendor -->
<div id="addVendorModal" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content modal-change">
		    <div class="modal-header modal-header-chng">
		        <h4 class="modal-title modal-title-change">Add Vendor</h4>
		        <div class="iconbox">
		          <button type="button" class="close close-icon" data-dismiss="modal" (click)="resetForm()">&times;</button>
		        </div>
		    </div>
		  
            <div class="modal-body modal-body-change">
        
  
			    <div class="row" >
			    	<div class="col-12" style="padding: 0">
			      	   <div class="form">
			        	<form [formGroup]="vendorForm" (ngSubmit)="onVendorFormSubmit()">
			        	  <!-- <pre>{{ vendorForm.value | json }}</pre>	 -->
			        	   <div class="row-change">
				        	    <div class="check" *ngIf="this.selectedSet == 'first'">
				        	  	 <div class="row">
					              	<div class="col-md-6 mt-3">
					              		<label class="name">Name <span class="text-danger">*</span></label>
					              		<input type="text" formControlName="name" class="form-control" placeholder="Enter  Name">
					              		<!-- <div class="alert" *ngIf="!vendorForm.controls['name'].valid && vendorForm.controls['name'].touched">This is required</div> -->
					              	</div>
					              	<div class="col-md-6 mt-3">
					              		<label class="dimension">Address <span class="text-danger">*</span></label>
					              		<input type="text" formControlName="address" class="form-control" placeholder="Enter Address">

					              	</div>

					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Contact Person<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="contact_person" class="form-control" placeholder="Enter Contact Person">
					              	</div> 
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Mobile Number<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="contact_number" class="form-control" placeholder="Enter Mobile Number">
					              		<!-- <div class="alert" *ngIf="!vendorForm.controls['contact_number'].valid && vendorForm.controls['contact_number'].touched">This is required</div> -->
					              		<div *ngIf="vendorForm.controls['contact_number'].errors && !vendorForm.controls['contact_number'].pristine" class="text-danger">

						                  <div [hidden]="vendorForm.controls['contact_number'].valid">Enter valid Number.</div>
						                </div>

					              	</div>  
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Email Address<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="email" class="form-control" placeholder="Enter Email">
					              		<div *ngIf="vendorForm.controls['email'].errors && !vendorForm.controls['email'].pristine" class="text-danger">

						                  <div [hidden]="vendorForm.controls['email'].valid">Enter valid email.</div>
						                </div>
					              		
					              	</div>                	
					              </div>
				        	    </div>
				        	    <div class="check" *ngIf="this.selectedSet == 'second'">
				        	  	  <div class="row " >

					              	<div class="col-md-6 mt-3">
					              		<label class="name">Pan Number <span class="text-danger">*</span></label>
					              		<input type="text" formControlName="pan_no" class="form-control" placeholder="Enter  Name" (change)="panInputChange($event)" id="PanId">
					              		<div *ngIf="vendorForm.controls['pan_no'].errors && !vendorForm.controls['pan_no'].pristine" class="text-danger" >

						                  <div [hidden]="vendorForm.controls['pan_no'].valid">Enter valid pan number.</div>
						                </div>
					              		
					              	</div>
					              	<div class="col-md-6 mt-3">
					              		<label class="dimension">GST Number <span class="text-danger">*</span></label>
					              		<input type="text" formControlName="gst_reg_no" class="form-control" placeholder="Enter Data">
					              	</div>

					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Account Holder Name<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="account_holder" class="form-control" placeholder="Enter Data">
					              	</div> 
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Account Number<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="account_number" class="form-control" placeholder="Enter Data">
					              	</div>  
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Bank Name<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="bank_name" class="form-control" placeholder="Enter Data">
					              	</div>  
					                <div class="col-md-6 mt-3">
					              		<label class="core_material">Branch Name<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="branch_name" class="form-control" placeholder="Enter Data">
					              	</div>  
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">IFSC Code<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="ifsc_code" class="form-control" placeholder="Enter Data">
					              	</div>  
					                <div class="col-md-6 mt-3">
					              		<label class="core_material">Upload Pan</label>
					              		<input type="file" class="form-control" formControlName="pan_copy" placeholder="Enter Image" (change)="onChange($event,i)">
					              	</div> 
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Upload GST</label>
					              		<input type="file" formControlName="gst_copy" class="form-control" placeholder="Enter Iamge" (change)="onChange1($event,i)">

					              	</div>  
					                <div class="col-md-6 mt-3">
					              		<label class="core_material">Upload Cancelled Cheque</label>
					              		<input type="file" formControlName="cancelled_cheque" class="form-control" placeholder="Enter Data" (change)="onChange2($event,i)">
					              	</div>  
					              	        	
					               </div>
				        	    </div>
				        	    <div class="check" *ngIf="this.selectedSet == 'third'">
					        	  	<div class="row">
			                  	<div class="col-md-5 mt-3" >
					              		<label class="name">Category <span class="text-danger">*</span></label>
					              		<select formControlName="category_ids" class="form-control" (change)="getSubCategories($event)">
						                    <option value="" disabled>Choose</option>
						                    <option value="{{cb.id}}" *ngFor="let cb of categories">{{cb.category_name}}</option>
						                </select>
					              	</div>
					              	<div class="col-md-5 mt-3">
					              		<label class="dimension">Subcategory <span class="text-danger">*</span></label>
					              		<select class="form-control" (change) = "setCurrentSubCategory($event)" >
						                    <option value="" disabled>Choose</option>
						                    <option value="{{subC.id}}" *ngFor="let subC of subCategoryList">{{subC.category_name}}</option>
						                </select>
					              	</div>
					              	<div class="col-md-2 mt-5">
					              		<input type="button" class = "btn btn-pink" name="" value="Add" (click) = "AddSubCategories()" >
					              	</div>
					              	<div class="col-md-12 mt-3">
					              		<span class="badge badge-primary mr-3" *ngFor="let item of selected_cate_subcate_list">{{item.category_name}} - {{item.subcategory_name}}
					              		<i class="fa fa-close" (click)="removeItem(item.subcategory_id)"></i>
					              		</span>
					              	</div>
						              	
						            </div>  	
						            <div class="row">  	
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material"> City<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="city" class="form-control" placeholder="Enter Data">
					              	</div>  
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material"> Servicable City<span class="text-danger">*</span></label>
								            <angular2-multiselect [data]="dropdownCityList" [(ngModel)]="selectedServicableCity"
													    [settings]="dropdownSscSettings"
													    (onSelect)="onSscItemSelect($event)"
													    (onDeSelect)="OnSscItemDeSelect($event)"
													    (onSelectAll)="onSscSelectAll($event)"
													    (onDeSelectAll)="onSscDeSelectAll($event)"
													    (change)="onSscCheckChange($event)"
							                formControlName="serviceable_city_ids"
													    ></angular2-multiselect>
					              	</div>

						            </div>
					            </div>  	
			                </div>
			             <div class="footer-changes">
			                <a class="nav-link  text-center" (click)="getSet('second')" *ngIf="selectedSet == 'first'">Next Step</a>
			                <div class="row">
			                	<div class="col-md-6">
			                	  <a class="nav-link  text-center text-chng" (click)="getSet('first')" *ngIf="selectedSet == 'second'">Back</a>
			                	</div>
			                	<div class="col-md-6">
			                		<a class="nav-link  text-center" (click)="getSet('third')" *ngIf="selectedSet == 'second'">Next</a>
			                	</div>
			                	<div class="col-md-6" style="padding-right:0">
			                	  <a class="nav-link  text-center text-chng" (click)="getSet('second')" *ngIf="selectedSet == 'third'" style="width: 100%">Back</a>
			                	</div>
			                	<div class="col-md-6" style="padding-left: 0">
			                		<!-- <a class="nav-link  text-center" *ngIf="selectedSet == 'third'" (click)="onVendorFormSubmit()">Submit</a> -->
                                    <input type="submit" class="btn btn-primary btn-chng "  style="width: 100%" *ngIf="selectedSet == 'third'">
			                	
			                		

			                		
			                	</div>
			                	
			                </div>

			             </div>
			  
			        	</form>
			            </div>
			        </div>    
			      	       
			    </div>
            </div>

        </div>

    </div>
</div>
<!-- MOdal ends here -->

<!-- MOdal For Update Vendor -->
<div id="vendorUpdateModal" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content modal-change">
		    <div class="modal-header modal-header-chng">
		        <h4 class="modal-title modal-title-change">Edit Vendor</h4>
		        <div class="iconbox">
		          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
		        </div>
		    </div>
		  
            <div class="modal-body modal-body-change">
        
  
			    <div class="row" >
			    	<div class="col-12" style="padding: 0">
			      	   <div class="form">
			        	<form [formGroup]="vendorUpdateForm" (ngSubmit)="onVendorUpdateFormSubmit()">
			        	  <!-- <pre>{{ vendorUpdateForm.value | json }}</pre>	 -->
			        	   <div class="row-change">
				        	    <div class="check" *ngIf="this.selectedSet == 'first'">
				        	  	 <div class="row">
					              	<div class="col-md-6 mt-3">
					              		<label class="name">Name <span class="text-danger">*</span></label>
					              		<input type="text" formControlName="name" class="form-control" placeholder="Enter  Name">
					              		<!-- <div class="alert" *ngIf="!vendorForm.controls['name'].valid && vendorForm.controls['name'].touched">This is required</div> -->
					              	</div>
					              	<div class="col-md-6 mt-3">
					              		<label class="dimension">Address <span class="text-danger">*</span></label>
					              		<input type="text" formControlName="address" class="form-control" placeholder="Enter Address">

					              	</div>

					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Contact Person<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="contact_person" class="form-control" placeholder="Enter Contact Person">
					              	</div> 
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Mobile Number<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="contact_number" class="form-control" placeholder="Enter Mobile Number">
					              		<div *ngIf="vendorUpdateForm.controls['contact_number'].errors && !vendorUpdateForm.controls['contact_number'].pristine" class="text-danger">

						                  <div [hidden]="vendorUpdateForm.controls['contact_number'].valid">Enter valid Number.</div>
						                </div>
					              	</div>  
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Email Address<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="email" class="form-control" placeholder="Enter Email">
					              		<div *ngIf="vendorUpdateForm.controls['email'].errors && !vendorUpdateForm.controls['email'].pristine" class="text-danger">

						                  <div [hidden]="vendorUpdateForm.controls['email'].valid">Enter valid email.</div>
						                </div>
					              		
					              	</div>                	
					              </div>
				        	    </div>
				        	    <div class="check" *ngIf="this.selectedSet == 'second'">
				        	  	  <div class="row " >

					              	<div class="col-md-6 mt-3">
					              		<label class="name">Pan Number <span class="text-danger">*</span></label>
					              		<input type="text" formControlName="pan_no" class="form-control" placeholder="Enter  Name" (change)="panInputUpdateChange($event)" id="PanIdChng">
					              		<div *ngIf="vendorUpdateForm.controls['pan_no'].errors && !vendorUpdateForm.controls['pan_no'].pristine" class="text-danger">

						                  <div [hidden]="vendorUpdateForm.controls['pan_no'].valid">Enter valid pan number.</div>
						                </div>
					              		
					              	</div>
					              	<div class="col-md-6 mt-3">
					              		<label class="dimension">GST Number <span class="text-danger">*</span></label>
					              		<input type="text" formControlName="gst_reg_no" class="form-control" placeholder="Enter Data">
					              	</div>

					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Account Holder Name<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="account_holder" class="form-control" placeholder="Enter Data">
					              	</div> 
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Account Number<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="account_number" class="form-control" placeholder="Enter Data">
					              	</div>  
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Bank Name<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="bank_name" class="form-control" placeholder="Enter Data">
					              	</div>  
					                <div class="col-md-6 mt-3">
					              		<label class="core_material">Branch Name<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="branch_name" class="form-control" placeholder="Enter Data">
					              	</div>  
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">IFSC Code<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="ifsc_code" class="form-control" placeholder="Enter Data">
					              	</div>  
					                <div class="col-md-6 mt-3">
					              		<label class="core_material">Upload Pan</label>
					              		<input type="file"  class="form-control" placeholder="Enter Image" (change)="onChange($event,i)" formControlName="pan_copy">
					              		<a href="{{ vendor_details.pan_copy }}" class="download-change" target="_blank" *ngIf="vendor_details">Download</a>

					              	</div> 
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material">Upload GST</label>
					              		<input type="file" formControlName="gst_copy" class="form-control" placeholder="Enter Iamge" (change)="onChange1($event,i)">
					              		<a href="{{ vendor_details.gst_copy }}" class="download-change" target="_blank" *ngIf="vendor_details">Download</a>

					              	</div>  
					                <div class="col-md-6 mt-3">
					              		<label class="core_material">Upload Cancelled Cheque</label>
					              		<input type="file" formControlName="cancelled_cheque" class="form-control" placeholder="Enter Data" (change)="onChange2($event,i)">
					              		<a href="{{ vendor_details.cancelled_cheque }}" class="download-change" target="_blank" *ngIf="vendor_details">Download</a>
					              	</div>  
					              	        	
					               </div>
				        	    </div>
				        	    <div class="check" *ngIf="this.selectedSet == 'third'">
					        	  	<div class="row">
			                  	<div class="col-md-5 mt-3" >
					              		<label class="name">Category <span class="text-danger">*</span></label>
					              		<select formControlName="category_ids" class="form-control" (change)="getSubCategories($event)">
						                    <option value="" disabled>Choose</option>
						                    <option value="{{cb.id}}" *ngFor="let cb of categories">{{cb.category_name}}</option>
						                </select>
					              	</div>
					              	<div class="col-md-5 mt-3">
					              		<label class="dimension">Subcategory <span class="text-danger">*</span></label>
					              		<select class="form-control" (change) = "setCurrentSubCategory($event)" >
						                    <option value="" disabled>Choose</option>
						                    <option value="{{subC.id}}" *ngFor="let subC of subCategoryList">{{subC.category_name}}</option>
						                </select>
					              	</div>
					              	<div class="col-md-2 mt-5">
					              		<input type="button" class = "btn btn-pink" name="" value="Add" (click) = "AddSubCategories('edit')" >
					              	</div>
					              	<div class="col-md-12 mt-3">
					              		<span class="badge badge-primary mr-3" *ngFor="let item of selected_cate_subcate_list_update">{{item.category_name}} - {{item.subcategory_name}}
                                        <i class="fa fa-close" (click)="removeUpdateItem(item.subcategory_id)"></i>
					              		</span>
					              	</div>
						              	
						            </div>  	
						            <div class="row">  	
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material"> City<span class="text-danger">*</span></label>
					              		<input type="text" formControlName="city" class="form-control" placeholder="Enter Data">
					              	</div>  
					              	<div class="col-md-6 mt-3">
					              		<label class="core_material"> Servicable City<span class="text-danger">*</span></label>
								            <angular2-multiselect [data]="dropdownCityList" [(ngModel)]="selectedServicableCity"
													    [settings]="dropdownSscSettings"
													    (onSelect)="onSscItemSelect($event)"
													    (onDeSelect)="OnSscItemDeSelect($event)"
													    (onSelectAll)="onSscSelectAll($event)"
													    (onDeSelectAll)="onSscDeSelectAll($event)"
													    (change)="onSscCheckChange($event)"
							                formControlName="serviceable_city_ids"
													    ></angular2-multiselect>
					              	</div>

						            </div>
					            </div>  	
			                </div>
			             <div class="footer-changes">
			                <a class="nav-link  text-center" (click)="getSet('second')" *ngIf="selectedSet == 'first'">Next Step</a>
			                <div class="row">
			                	<div class="col-md-6">
			                	  <a class="nav-link  text-center text-chng" (click)="getSet('first')" *ngIf="selectedSet == 'second'">Back</a>
			                	</div>
			                	<div class="col-md-6" >
			                		<a class="nav-link  text-center" (click)="getSet('third')" *ngIf="selectedSet == 'second'">Next</a>
			                	</div>
			                	<div class="col-md-6" style="padding-right: 0">
			                	  <a class="nav-link  text-center text-chng" (click)="getSet('second')" *ngIf="selectedSet == 'third'" style="width: 100%">Back</a>
			                	</div>
			                	<div class="col-md-6" style="padding-left: 0">
			                		<!-- <a class="nav-link  text-center" *ngIf="selectedSet == 'third'" (click)="onVendorUpdateFormSubmit()">Update</a> -->
			                		<input type="submit" class="btn btn-primary btn-chng "  style="width: 100%" *ngIf="selectedSet == 'third'" value="Update">
			                	

			                		
			                	</div>
			                	
			                </div>

			             </div>
			  
			        	</form>
			            </div>
			        </div>    
			      	       
			    </div>
            </div>

        </div>

    </div>
</div>




// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/category/category/vendor/vendor.component.html